import ProductAuthorSlider from "./product-author-slider";

export default ProductAuthorSlider;